import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Document } from 'src/app/shared/models/documents/document';
import { DocumentRequest } from '../shared/models/documents/document-request';
import { UpdateDocumentRequest } from 'src/app/shared/models/documents/update-document-request';

@Injectable({
  providedIn: 'root',
})
export class DocumentService {
  env = environment;
  apiUrl = this.env.apiurl + 'platform/document/';

  constructor(
    private http: HttpClient,
    public router: Router
  ) {}

  public SendDocumentData(DocRequest: DocumentRequest): Observable<Document> {
    return this.http.post<Document>(`${this.apiUrl}`, DocRequest);
  }

  public GetDocumentsByUserId(userId: number): Observable<Document[]> {
    return this.http.get<Document[]>(`${this.apiUrl}${userId}`);
  }

  public UpdateDocumentData(UpdateDocRequest: UpdateDocumentRequest): Observable<Document> {
    return this.http.post<Document>(`${this.apiUrl}update`, UpdateDocRequest);
  }
}
